'use strict';

namespace Core {

    const pixelTrackingPageNames = {
        holidaysHotelsSearchResults: 'HolidaysHotelsSearchResults',
        holidaysRoomSelection: 'HolidaysRoomSelection',
        holidaysOptions: 'HolidaysOptions',
        holidaysFlightSearch: 'HolidaysFlightSearch',
        holidaysBookingForm: 'HolidaysBookingForm',
        bookingComplete: 'BookingComplete',
        termsAgency: 'TermsAgency',
        dashboardBookingReference: 'MybBookingReference',
        dashboardBookingDetails: 'DashboardBookingDetails',
        dashboardPayBalance: 'DashboardPayBalance',
        bookingAlreadyDone: 'BookingA0lreadyDone',
        landingPage: 'LandingPage',
        pageNotFound: 'PageNotFound',
        errorPage: 'ErrorPage',
        errorDatesMismatch: 'ErrorDateMismatch',
        holidaysJanuarySale: 'HolidaysJanuarySale',
        homePage: 'HomePage',

        hotelsSearchResults: 'HotelsSearchResults',
        hotelsRoomSelection: 'HotelsRoomSelection',
        hotelsOptions: 'HotelsOptions',
        hotelsBookingForm: 'HotelsBookingForm',

        flightsSearchResults: 'FlightsSearchResults',
        flightsBookingForm: 'FlightsBookingForm',

        transfersSearchResults: 'TransfersSearchResults',
        transfersBookingForm: 'TransfersBookingForm',

        marhabaSearchResults: 'MarhabaSearchResults',
        marhabaOptions: 'MarhabaOptions',
        marhabaBookingForm: 'MarhabaBookingForm',

        insuranceSearchResults: 'InsuranceSearchResults',
        insuranceBookingForm: 'InsuranceBookingForm'

    };

    export interface IPageTrackingData {
        name: string;
        label?: string;
    }

    export abstract class BaseTracking {
        private routeHasChanged: boolean;
        private lastPageRoute: string;

        constructor (
            protected $scope: ng.IScope,
            protected $rootScope: ng.IRootScopeService,
            protected $q: ng.IQService,
            protected $location: ng.ILocationService
        ) {}

        protected _onInit(): void {
           this.$rootScope.$on('$routeChangeSuccess', (e, {$$route}) => {
               this.routeHasChanged = this._isRouteChanged();
               const isTracked = this._isRouteTracked($$route);
               if (!isTracked) {
                    this.notTrackedRouteHandler();
                    return;
               }
               if (!this.routeHasChanged) {
                   this.notChangedRouteHandler();
                   return;
               }
               const page = {
                   name: pixelTrackingPageNames[$$route.pixelTrackingPageName],
                   label: $$route.pixelTrackingPageName
               };
               this.routeChanged(page);
           });

           this.$rootScope.$on('cmsPageProps', (e, {pageName}) => {
               const page = {
                   name: `CmsPage:${pageName}`
               };
               if (!this.routeHasChanged) {
                   this.notChangedRouteHandler();
                   return;
               }
               this.cmsRouteChanged(page);
           });
        }

        protected abstract notChangedRouteHandler(): void;
        protected abstract notTrackedRouteHandler(): void;
        protected abstract routeChanged(pageData: IPageTrackingData): void;
        protected abstract cmsRouteChanged(page: IPageTrackingData): void;

        private _isRouteTracked(route) {
            return route && route.pixelTrackingPageName && pixelTrackingPageNames[route.pixelTrackingPageName];
        }

        private _isRouteChanged() {
            const curUrl = this.$location.path();
            if (curUrl !== this.lastPageRoute) {
                this.lastPageRoute = curUrl;
                return true;
            }
            return false;
        }

    }
}
